<div class="container-tig-item">
    <div class="help-c-title">
        <h4>嵌入小程序</h4>
    </div>
    <div>
        <h4>嵌入微信小程序</h4>
        <br>
        <p>嵌入微信小程序之前我先把下载好的字体文件（*.ttf,*.otf,*.woff,*.woff2,*.svg 格式中的任一个）进行base64加密。</p>
        <br>
        <p> 在线加密网址：</p>
        <p>
            <a href="https://transfonter.org/" target="_blanck">https://transfonter.org/</a>
        </p>
        <br>
        <p>打开网页后，点击“Add fonts”选择已下载好的字体:</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/applets-01.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>上传完成后选择 “Base64 encode”, 然后根据需求选择字体格式：</p>

        <br>
        <div class="az-img">
            <img src="/assets/images/syff/applets02.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>点击“Download”，下载᠄</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/applets03.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <p>将下载完成的文件解压，解压后 打开 “stylesheet.css” 文件, 把内容复制到样式文件 *.wxss 便可。</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/applets04.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <br>
    </div>
</div>